import CompanyActionTypes from './company.type';

const INITIAL_STATE = null;

const companyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CompanyActionTypes.SET_COMPANY:
      return action.payload;
    default:
      return state;
  }
};

export default companyReducer;
